import { Dislike, Share } from 'iconsax-react'

import { useRouter } from 'next/router'

import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

import { addCommaToNumber, checkIfDateIsAfter } from '@/utils'
import ViewCompanyProfileJobSeeker from '@/components/Modals/ViewCompanyProfileJobSeeker'
import { CustomJobApplyForm, useJob } from '@/features/job-seeker'
import { Tooltip } from '@mui/material'
import { Avatar } from '@mui/material'
import { BsDot } from 'react-icons/bs'
import dayjs from 'dayjs'

import { LoginPopUp, ReportJob, ShareJob } from '@/components'
import { useAuth } from '@/contexts/Authentication'
import { FullPageLoader } from '@/features/auth'
import { useUserInfo } from '@/hooks'
import clsx from 'clsx'

const Index = () => {
  const { authState } = useAuth()
  const { user } = useUserInfo()
  const { isRecruiter } = user || {}

  const [openReportJob, setOpenReportJob] = React.useState(false)
  const [openShareJob, setOpenShareJob] = React.useState(false)
  const [openCompanyProfile, setOpenCompanyProfile] = React.useState(false)
  const [openLoginPopUp, setOpenLoginPopUp] = React.useState(false)
  const [openLoginPopUpCompanyProfile, setOpenLoginPopUpCompanyProfile] =
    React.useState(false)

  const router = useRouter()
  const { id: jobId } = router.query

  const { data, isLoading: jobDataIsLoading } = useJob(jobId as string)

  const {
    companyId,
    companyName,
    companyLocation,
    companyLogo,
    title,
    applicants,
    availableOpenings,
    datePosted,
    description,
    jobLocation,
    isSpotlighted,
    // employeeCount,
    employmentType,
    level,
    summary,
    validThrough,
    experience,
    minQualification,
    salary,
    workType,
    isAnonymous,
  } = data?.data || {}

  const { currency, min, max, term, hidden } = salary || {}
  const formattedDeadline = dayjs(validThrough).fromNow()

  const handleOpenReportModal = () => {
    if (authState.isAuthenticated === false) {
      setOpenLoginPopUp(true)
    } else {
      setOpenReportJob(true)
    }
  }

  const handleOpenShareModal = () => setOpenShareJob(true)

  const handleOpenCompanyProfile = () => {
    if (authState.isAuthenticated === false) {
      setOpenLoginPopUpCompanyProfile(true)
    } else {
      setOpenCompanyProfile(true)
    }
  }

  const isApplicationClosed = checkIfDateIsAfter(validThrough)
  authState.isAuthenticated
  const formattedPostedDate = dayjs(datePosted).fromNow()

  const locationArr = companyLocation?.split(',') || []
  const state = locationArr[locationArr.length - 2]
  const country = locationArr[locationArr.length - 1]

  return (
    <>
      <div className="sm:w-full">
        <div className="grid justify-items-center py-6 shadow-md">
          <Link href="/">
            <Image
              src="/assets/logo-black.png"
              alt="scout4Job-logo"
              className="cursor-pointer"
              height={41.65}
              width={162.05}
            />
          </Link>
        </div>
      </div>
      {jobDataIsLoading ? (
        <div>
          <FullPageLoader />
        </div>
      ) : (
        <div className="mx-auto max-w-[1600px] pl-8 py-8">
          {/* <h3 className="my-6 text-center">Application for Job {title}</h3> */}
          <div>
            <div
              className={clsx(
                'grid ',
                isRecruiter
                  ? 'place-items-center'
                  : 'grid-cols-1 gap-6 lg:grid-cols-2'
              )}
            >
              <div className={clsx('', isRecruiter && 'place-items-center')}>
                <div className="rounded-[10px] border bg-gray-350 px-6 py-12">
                  <div className="flex flex-col justify-start gap-10 rounded-md transition duration-200 md:flex-row md:justify-between md:gap-0 ">
                    <div className="flex h-fit items-center gap-6">
                      <div>
                        {isAnonymous ? (
                          <Avatar
                            sx={{ bgcolor: '#000', width: 60, height: 60 }}
                          >
                            <span className="text-2xl">A</span>
                          </Avatar>
                        ) : (
                          <>
                            {companyLogo ? (
                              <Image
                                src={companyLogo}
                                alt={`${companyName} logo`}
                                height={60}
                                width={60}
                              />
                            ) : (
                              <Avatar
                                sx={{ bgcolor: '#000', width: 60, height: 60 }}
                              >
                                <span className="text-2xl">
                                  {companyName && companyName[0]}
                                </span>
                              </Avatar>
                            )}
                          </>
                        )}
                      </div>
                      <div>
                        <div className="flex items-start justify-between">
                          <div>
                            <h2 className="text-left text-sm font-bold sm:text-base">
                              {title}
                            </h2>
                            <p className="flex items-center text-left text-xs text-gray-400 sm:text-sm">
                              {isAnonymous ? (
                                'Anonymous'
                              ) : (
                                <button
                                  type="button"
                                  onClick={handleOpenCompanyProfile}
                                  className="hover:underline"
                                >
                                  {companyName}{' '}
                                </button>
                              )}
                              <BsDot className="text-left text-lg text-gray-400" />
                              {state}
                              {state && country && ','} {country}
                            </p>
                          </div>
                          <div>
                            {/* <div className="">
                          {saveState ? (
                            <button onClick={() => handleUnSaveJobs(jobId)}>
                              <Save2
                                size="20"
                                color="#2F80ED"
                                variant="Bold"
                                className=""
                              />
                            </button>
                          ) : (
                            <button
                              onClick={() => handleSaveJobs({ jobId: jobId })}
                            >
                              <Save2
                                size="20"
                                color="#2F80ED"
                                variant="Outline"
                              />
                            </button>
                          )}
                        </div> */}
                          </div>
                        </div>
                        <div className="items mt-2 flex flex-wrap items-center gap-1 whitespace-nowrap text-[10px]">
                          <span className="text-xs text-gray-400">
                            Posted {formattedPostedDate}
                          </span>
                          <div className="text-base text-gray-400">
                            <BsDot />
                          </div>
                          <span className="text-xs text-[#EB5757]">
                            {isApplicationClosed ? (
                              'Application Closed'
                            ) : (
                              <p>Closing {formattedDeadline}</p>
                            )}
                          </span>
                          {!isSpotlighted && (
                            <>
                              <div className="text-base text-gray-400">
                                <BsDot />
                              </div>
                              <span className="text-xs text-gray-400">
                                {availableOpenings}{' '}
                                {availableOpenings &&
                                Number(availableOpenings) > 1
                                  ? 'Openings'
                                  : 'Opening'}
                              </span>
                            </>
                          )}
                          {!isSpotlighted && (
                            <>
                              <div className="text-xs text-gray-400">
                                <BsDot />
                              </div>
                              <span className="text-blue-400">
                                {applicants} Applicant
                                {applicants && applicants > 1 ? 's' : ''}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col items-start justify-between">
                      <div className="flex items-center justify-between space-x-2">
                        <button
                          type="button"
                          className="flex items-center gap-1 rounded-lg bg-[#16BF44] py-1 px-2 text-sm text-white"
                          onClick={handleOpenShareModal}
                        >
                          <Share size="18" color="#ffff" />
                          
                        </button>
                        <button
                          type="button"
                          onClick={handleOpenReportModal}
                          className="flex items-center gap-1 rounded-lg border border-[#FF8A65] py-1 px-2 text-sm text-[#FF8A65]"
                        >
                          <Dislike size="18" color="#FF8A65" />
                          Report
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className=" mt-10 grid gap-4 rounded-lg border border-[#E6E5E5] py-6 px-4  md:grid-cols-3 md:flex-row">
                    <div className="border-r border-[#E6E5E5] px-2">
                      <p className="whitespace-nowrap  text-xs ">
                        Job Location
                      </p>
                      <Tooltip title={jobLocation}>
                        <p className=" mt-1 cursor-pointer truncate whitespace-nowrap text-sm font-medium">
                          {jobLocation}
                        </p>
                      </Tooltip>
                      <hr className="my-2" />
                      <p className="whitespace-nowrap  text-xs ">
                        Minimum Qualification
                      </p>
                      <p className=" mt-1  whitespace-nowrap  text-sm font-medium ">
                        {minQualification}
                      </p>
                    </div>
                    <div className="border-r border-[#E6E5E5] px-2">
                      <p className="whitespace-nowrap text-xs">
                        Experience Level
                      </p>
                      <p className=" mt-1 whitespace-nowrap text-sm font-medium line-clamp-1">
                        {level}
                      </p>
                      <hr className="my-2" />
                      <p className="whitespace-nowrap  text-xs ">
                        Experience Length
                      </p>
                      <p className=" mt-1  whitespace-nowrap  text-sm font-medium ">
                        {experience}{' '}
                      </p>
                    </div>
                    <div className=" px-2">
                      <p className="whitespace-nowrap  text-xs ">
                        Employment Type
                      </p>
                      <p className=" mt-1  whitespace-nowrap text-sm font-medium capitalize">
                        {employmentType} ({workType})
                      </p>
                      <hr className="my-2" />
                      <p className="whitespace-nowrap  text-xs ">Salary</p>
                      {hidden ? (
                        <p className="mt-1 whitespace-nowrap text-sm font-medium capitalize">
                          Confidential
                        </p>
                      ) : (
                        <>
                          <p className=" mt-1  whitespace-nowrap text-sm font-medium line-clamp-1 ">
                            {currency}
                            {addCommaToNumber(min || 0)}
                            {(max || 0) > 0 && (
                              <span>
                                {' - '}
                                {currency}
                                {addCommaToNumber(max || 0)}{' '}
                              </span>
                            )}{' '}
                            / <span>{term}</span>
                          </p>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="mt-5 border-b p-2 text-sm font-light">
                    <h5 className="text-sm font-semibold">Job Summary</h5>
                    <p className="mb-4 mt-2 leading-6 ">{summary}</p>
                  </div>
                  {/* TODO: SANITIZE HTML */}
                  <h5 className="pt-6 text-sm font-semibold">
                    Job Description/Requirements
                  </h5>
                  <div
                    className="job-description mt-2 text-sm "
                    dangerouslySetInnerHTML={{ __html: description || '' }}
                  ></div>
                </div>
              </div>
              {!isRecruiter && (
                <CustomJobApplyForm
                  jobId={jobId as string}
                  companyId={companyId || ''}
                />
              )}
            </div>
          </div>
        </div>
      )}
      <ReportJob
        openReportJob={openReportJob}
        setOpenReportJob={setOpenReportJob}
        jobId={jobId as string}
      />

      <LoginPopUp
        openLoginPopUp={openLoginPopUp}
        setOpenLoginPopUp={setOpenLoginPopUp}
        action="report this job"
      />

      <LoginPopUp
        openLoginPopUp={openLoginPopUpCompanyProfile}
        setOpenLoginPopUp={setOpenLoginPopUpCompanyProfile}
        action="view this company's profile"
      />

      <ShareJob
        openShareJob={openShareJob}
        setOpenShareJob={setOpenShareJob}
        jobId={jobId as string}
      />

      <ViewCompanyProfileJobSeeker
        openViewCompanyProfile={openCompanyProfile}
        setOpenViewCompanyProfile={setOpenCompanyProfile}
        companyId={companyId ?? ''}
      />
    </>
  )
}

export default Index
